import * as React from "react"
const Check = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 34 34"
		width="34"
		height="34"
		fill="none"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<circle cx="17" cy="17" r="16" fill="#0086C9" stroke="white" strokeWidth="1"  />
		<path d="M10.2 16.6 L15.4 22 L26 10.8" stroke="white" strokeWidth="2" fill="none" />
	</svg>
)
export default Check
